module.exports = __webpack_public_path__ + "img/Spinner.6430616a.gif";